var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "post-info caps-small"
  }, [_c('div', {
    staticClass: "box-container"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 14 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.75 2H9.25V0.75C9.25 0.34375 9.5625 0 10 0C10.4062 0 10.75 0.34375 10.75 0.75V2H12C13.0938 2 14 2.90625 14 4V14C14 15.125 13.0938 16 12 16H2C0.875 16 0 15.125 0 14V4C0 2.90625 0.875 2 2 2H3.25V0.75C3.25 0.34375 3.5625 0 4 0C4.40625 0 4.75 0.34375 4.75 0.75V2ZM1.5 14C1.5 14.2812 1.71875 14.5 2 14.5H12C12.25 14.5 12.5 14.2812 12.5 14V6H1.5V14Z",
      "fill": "#E2001A"
    }
  })]), _c('div', {
    staticClass: "published-date caps-small"
  }, [_vm._v(_vm._s(_vm._f("viFormatDate")(_vm.post.details.publishedAt)))])]), _vm._l(_vm.post.categories, function (category) {
    return _c('div', {
      key: category.id,
      staticClass: "box-container"
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 16 14",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 2C0 0.90625 0.875 0 2 0H14C15.0938 0 16 0.90625 16 2V12C16 13.125 15.0938 14 14 14H2C0.875 14 0 13.125 0 12V2ZM6 4.25H14.5V2C14.5 1.75 14.25 1.5 14 1.5H6V4.25ZM4.5 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V4.25H4.5V1.5ZM1.5 5.75V8.25H4.5V5.75H1.5ZM1.5 9.75V12C1.5 12.2812 1.71875 12.5 2 12.5H4.5V9.75H1.5ZM6 12.5H14C14.25 12.5 14.5 12.2812 14.5 12V9.75H6V12.5ZM14.5 8.25V5.75H6V8.25H14.5Z",
        "fill": "#1B1C1D"
      }
    })]), _c('div', {
      staticClass: "caps-small"
    }, [_vm._v(_vm._s(category.details ? category.details.title : category.defaultTranslation.title))])]);
  }), _c('div', {
    staticClass: "box-container"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.25 3.75C7.25 3.34375 7.5625 3 8 3C8.40625 3 8.75 3.34375 8.75 3.75V7.625L11.4062 9.375C11.75 9.625 11.8438 10.0938 11.5938 10.4375C11.375 10.7812 10.9062 10.875 10.5625 10.625L7.5625 8.625C7.375 8.5 7.25 8.25 7.25 8V3.75ZM8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0ZM1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C11.5625 14.5 14.5 11.5938 14.5 8C14.5 4.4375 11.5625 1.5 8 1.5C4.40625 1.5 1.5 4.4375 1.5 8Z",
      "fill": "#1B1C1D"
    }
  })]), _c('div', {
    staticClass: "reading-time caps-small"
  }, [_vm._v(_vm._s(_vm.$t('blog.min_read', {
    min: _vm.post.details.timeToRead
  })) + " ")])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }